<div class="pleaseWait" #appLoading id="appLoading" [hidden]="!showLoading || isErrorPage"></div>
<nav *ngIf="!hideNav" class="navbar navbar-expand bgAccent topMenu" (click)="topMenuClick($event)">
  <app-notifier></app-notifier>
  <div class="navbar-collapse collapse w-100 order-1 order-md-0 dual-collapse2">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <span class="navbar-brand textWhite">
          SLIM-Collaborate
        </span>
      </li>
      <li class="nav-item" *ngIf="showTopMenuItems">
        <a class="nav-link textWhite navLink" href="{{WebAppName}}/Views/Services/Portfolio/Portfolio_Default.aspx">Project List</a>
      </li>
      <kendo-menu (select)="topMenuClick($event)" *ngIf="showTopMenuItems">
        <kendo-menu-item cssClass="textWhite" text="Preferences">
          <kendo-menu-item cssClass="textAccent navLink" text="Manage Account" url="{{WebAppName}}/Views/MyAccount/Preferences.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink" text="Manage Dashboards" url="dashboard-management"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink" text="Manage Filters" url="{{WebAppName}}/Views/MyAccount/SavedFilters.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink">
            <ng-template kendoMenuItemLinkTemplate>
              <a class="k-link k-menu-group k-menu-link" (click)="OpenEmailNotification()">Manage Email Notifications</a>
            </ng-template>
          </kendo-menu-item>
        </kendo-menu-item>
      </kendo-menu>
      <kendo-menu *ngIf="showBackOffice && showTopMenuItems" (select)="topMenuClick($event)">
        <kendo-menu-item cssClass="textWhite" text="Back Office">
          <kendo-menu-item cssClass="textAccent navLink" text="Configuration Set Management" *ngIf="showBackOfficeItems" url="{{WebAppName}}/Views/BackOffice/ConfigSets.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink" text="Template Management" *ngIf="showBackOfficeItems" url="{{WebAppName}}/Views/BackOffice/BackOffice_Default.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink" text="Trend Management" *ngIf="showBackOfficeItems" url="{{WebAppName}}/Views/BackOffice/TrendGroups.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink" text="Contingency Profiles" *ngIf="showBackOfficeItems" url="{{WebAppName}}/Views/BackOffice/ContingencyProfiles.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent navLink" text="Export Closeout Projects" *ngIf="showImportCloseout" url="{{WebAppName}}/Views/BackOffice/ExportCloseoutProjects.aspx"></kendo-menu-item>
          <kendo-menu-item cssClass="textAccent" text="Import Projects" *ngIf="showImportEstimate || showImportCloseout">
            <kendo-menu-item cssClass="textAccent navLink" text="Import Estimation Projects" *ngIf="showImportEstimate" url="{{WebAppName}}/Views/BackOffice/ImportSew.aspx"></kendo-menu-item>
            <kendo-menu-item cssClass="textAccent navLink" text="Import Closeout Projects" *ngIf="showImportCloseout" url="{{WebAppName}}/Views/BackOffice/ImportSmp.aspx"></kendo-menu-item>
          </kendo-menu-item>
        </kendo-menu-item>
      </kendo-menu>
      <li class="nav-item" *ngIf="showTopMenuItems">
        <a class="nav-link textWhite navLink fromContactUsLink" href="{{WebAppName}}/Views/MyAccount/ContactUs.aspx">Contact Us</a>
      </li>
      <li class="nav-item" *ngIf="showTopMenuItems">
        <a class="nav-link textWhite navLink" href="https://nethelp40.slimcollaborate.com" target="_blank" rel="noreferrer noopener">Help</a>
      </li>
    </ul>
  </div>
  <div class="navbar-collapse collapse w-100 order-3 dual-collapse2" *ngIf="showTopMenuItems">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <span class="nav-logo"></span>
      </li>
      <li class="nav-item textWhite">
        Welcome <span class="bold">
          {{userView.DisplayName}}! <a class="textOrange navLink" href="{{WebAppName}}/Account/Logout.aspx">[Logout]</a>
        </span>
      </li>
    </ul>
  </div>
</nav>
<div class='container-fluid'>
  <div class='row'>
    <div class='col-sm-12 body-content' [ngClass]="isContingencyDashboard ? 'contingency-dashboard' : 'bg-white'">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<ng-template #aspxIframeApp>
  <iframe [src]="aspxIframeSrcApp" [height]="aspxIframeHeight" [width]="aspxIframeWidth" frameborder="0"></iframe>
</ng-template>
<div kendoDialogContainer></div>
<div kendoWindowContainer></div>
<footer class="pl-3 border-top" *ngIf="!hideNav">
  Copyright © 2012 - {{currentYear}} by <a href="https://www.qsm.com" target="_blank">Quantitative Software Management, Inc.</a> All rights reserved. | Version {{version}} | <a (click)="showPrivacyPolicy()" class="btn-link cursorPointer">Privacy Policy</a>
</footer>
